import React, { useEffect, useState } from "react";
import { refreshAffiliateUrl } from "../../../api/RefreshAffiliateUrl";
import PrimaryButton from "../../shared/Buttons/PrimaryButton";
import SecondaryButton from "../../shared/Buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";

const ConnectBankAccount = () => {
  const [localUserData, setLocalUserData] = useState(null);
  const [refreshLink, setRefreshLink] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userDataString = localStorage.getItem("userData");
      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          setLocalUserData(userData);
          if (localUserData && localUserData.stripe_account) {
            const url = await refreshAffiliateUrl(userData.id);
            setRefreshLink(url);
          }
        } catch (error) {
          console.error("Failed to parse user data: ", error);
          localStorage.removeItem("userData");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("accessToken");
        }
      }
    };
    fetchData();
  }, []);

  return (
    <div className="m-0 lg:ml-14 lg:mt-10 p-4 w-full xl:w-4xl h-full">
      {localUserData && localUserData?.stripe_account ? (
        <>
          {localUserData.stripe_connect_url === "" ? (
            <div>
              <div className="border p-4 mb-8">
                <h2 className="text-2xl font-bold my-2 !text-orange">
                  Stripe Account
                </h2>
                {localUserData.stripe_account ? (
                  <div className="flex flex-row w-full gap-5">
                    <p className="basis-1/5 shrink-0 text-right font-bold pr-2.5">
                      Account ID
                    </p>
                    <p className="basis-4/5 grow-1 text-left">
                      {localUserData.stripe_account.id}
                    </p>
                  </div>
                ) : (
                  <p>No Stripe account found.</p>
                )}
              </div>
              {localUserData.stripe_account && (
                <div className="border p-4 mb-8">
                  <h2 className="text-2xl font-bold my-2 !text-orange">
                    Required Actions
                  </h2>
                  <p>Link your bank account</p>
                  <PrimaryButton
                    onClick={() => (window.location.href = refreshLink)}
                  >
                    Link
                  </PrimaryButton>
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="border p-4 mb-8">
                <h2 className="text-2xl font-bold my-2 !text-orange">
                  Stripe Account
                </h2>
                <div className="flex flex-row w-full gap-5">
                  <p className="basis-1/5 shrink-0 text-right font-bold pr-2.5">
                    Account ID
                  </p>
                  <p className="basis-4/5 grow-1 text-left">
                    {localUserData.stripe_account.id}
                  </p>
                </div>
              </div>
              {localUserData.stripe_account.charges_enabled === true ? (
                <div>
                  <p>Your bank account is connected!</p>
                </div>
              ) : (
                <div className="border p-4 mb-8">
                  <h2 className="text-2xl font-bold my-2 !text-orange">
                    Required Actions
                  </h2>
                  <p>
                    Complete the onboarding process to start receiving payments.
                  </p>
                  <div className="flex justify-center items-center">
                    {localUserData &&
                    localUserData.user_type === "affiliate" ? (
                      <SecondaryButton
                        onClick={() =>
                          (window.location.href = "/refresh-affiliate-connect")
                        }
                      >
                        Complete Onboarding
                      </SecondaryButton>
                    ) : (
                      <p>
                        Please contact support to complete the onboarding
                        process.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <div>
          <p>
            Thank you for registering as an affiliate with Sponsor A Pet! We use
            Stripe to process payments, and you can connect your bank account
            with us via Stripe.
            <br />
            There are no required actions for you currently.
          </p>
        </div>
      )}
    </div>
  );
};

export default ConnectBankAccount;
